import SiteLayout from "@/components/feature/SiteLayout";
import useSeo from "@/hooks/useSeo";
import { siteInfo } from "@/mocks/dramas";
import AboutIntro from "@/pages/about/components/AboutIntro";
import Principles from "@/pages/about/components/Principles";
import VoiceSection from "@/pages/about/components/VoiceSection";
import ContactSection from "@/pages/about/components/ContactSection";

const ABOUT_JSON_LD = [
  {
    "@context": "https://schema.org",
    "@type": "AboutPage",
    name: `关于${siteInfo.name}`,
    description: `${siteInfo.name}的品牌介绍、网站定位、内容原则与联系方式。`,
    inLanguage: "zh-CN",
    breadcrumb: {
      "@type": "BreadcrumbList",
      itemListElement: [
        { "@type": "ListItem", position: 1, name: "首页", item: "https://heiliao-theater.cn/" },
        { "@type": "ListItem", position: 2, name: "关于我们", item: "https://heiliao-theater.cn/about" },
      ],
    },
  },
  {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: siteInfo.name,
    description: "专注短剧排行榜、同款类似剧与新剧速递的内容平台。",
    email: siteInfo.email,
    slogan: siteInfo.slogan,
  },
  {
    "@context": "https://schema.org",
    "@type": "ContactPage",
    name: `联系${siteInfo.name}`,
    description: "内容纠错、好剧推荐与选题建议的联系方式。",
    inLanguage: "zh-CN",
  },
];

export default function About() {
  useSeo({
    title: `关于我们 - 黑料剧场品牌介绍与内容原则`,
    description:
      "了解黑料剧场的品牌定位、内容原则与联系方式：我们如何筛选短剧、评定评分、维护榜单，以及如何把同款类似剧推荐做得更准确。",
    keywords: "黑料剧场,关于我们,黑料短剧内容原则,短剧榜单说明,联系我们",
    path: "/about",
    jsonLd: ABOUT_JSON_LD,
  });

  return (
    <SiteLayout>
      <AboutIntro />
      <Principles />
      <VoiceSection />
      <ContactSection />
    </SiteLayout>
  );
}